<template>
	<div>
		<div class="follow-head">
			<div class="follow-head-con" v-for="(item, index) in myfol" :key="index">
				<img :src="item.avatar" alt class="follow-tx" />
				<div>
					<p class="follow-p">{{item.nickname}}</p>
					<p class="follow-p1">个性签名：{{item.bio}}</p>
				</div>
			</div>
		</div>
		<div class="follow-foot">
			<div class="block">
				<el-pagination
					@size-change="handleSizeChange"
					layout="total, sizes, prev, pager, next, jumper"
					:total="Number(myfol.length)"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			}
		},
		data() {
			return {
				myfol: ""
			};
		},
		beforeCreate() {
			this.$http
				.post("user/myfol/", {
					token: this.$cookies.get("token")
				})
				.then(res => {
					if (res.body.code == 1) {
						console.log(res);
						this.myfol = res.body.data;
						console.log(this.myfol);
					}
				});
		}
	};
</script>

<style  scoped="scoped">
	.follow-head {
		width: 900px;
		padding: 30px;
		box-sizing: border-box;
		border: 1px solid #e6e6e6;
		border-radius: 6px;
		background-color: #ffffff;
	}

	.follow-foot {
		width: 900px;
		display: flex;
		justify-content: center;
		background-color: #f5f5f5;
	}
	.follow-head-con {
		width: 100%;
		height: 70px;
		box-sizing: border-box;
		border-bottom: 1px solid #e6e6e6;
		display: flex;
		padding-top: 16px;
	}
	.follow-tx {
		width: 40px;
		height: 40px;
		margin-right: 20px;
		border-radius: 50%;
	}
	.follow-p {
		font-size: 14px;
	}
	.follow-p1 {
		font-size: 14px;
		margin-top: 10px;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>



// WEBPACK FOOTER //
// src/components/Usercenter/follow.vue